import './Availability.scss';

import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

import GroomersDropdown from 'organisms/GroomersDropdown';
import { UserAvatarSmall } from 'organisms/GroomersDropdown/UserAvatar';
import NewAppointmentButton from 'organisms/NewAppointmentButton';
import { DISPLAY_NEW_APPOINTMENT_BUTTON } from 'pages/Appointments/Header';

import AvailabilityDrawerContent from './Components/AvailabilityDrawerContent';
import PublishButton from './Components/PublishButton';

export default function AvailabilityDrawer() {
  const { isOwner, firstName } = useSelector((state) => state.user);
  const { date, startStr } = useSelector((state) => state.ui.drawer.data) || {};

  return (
    <div className="availability-drawer flex-column align-end">
      <div className="w-100">
        <div className="flex-row justify-between mb-25">
          <h2 className="f26">
            {date
              ? `${dayjs(new Date(date)).utc().format('MMM DD')}`
              : 'Weekly availability'}
          </h2>
          {DISPLAY_NEW_APPOINTMENT_BUTTON && (
            <NewAppointmentButton
              data={{
                date: {
                  date,
                  timeStart: startStr
                    ? startStr.split('T')[1].split('Z')[0]
                    : null,
                },
              }}
            />
          )}
        </div>
        {isOwner ? (
          <GroomersDropdown
            disableAllOption
            className="availability-drawer-groomers-dropdown"
            Element={UserAvatarSmall}
          />
        ) : (
          <div className="flex-row b-white border-light-purple mb-12 p-20 radius-24">
            <UserAvatarSmall />
            <p className="f14">{firstName}</p>
          </div>
        )}

        <AvailabilityDrawerContent />

        <div className="flex-row justify-end">
          <PublishButton />
        </div>
      </div>
    </div>
  );
}
